import { Plugin } from "@nuxt/types"

import * as enums from "@/enums"

const plugin: Plugin = (_ctx, inject) => {
  inject("enums", enums)
}

export default plugin
